import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-black text-white">高清电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              专注高清电影资源的分享与推荐，汇聚多类型佳片，帮你快速发现值得一看的电影。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-white">
              <Link to="/" className="cursor-pointer hover:text-accent-300">快速导航</Link>
            </h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li><Link to="/" className="cursor-pointer hover:text-accent-300">首页</Link></li>
              <li><Link to="/search" className="cursor-pointer hover:text-accent-300">搜索电影</Link></li>
              <li><Link to="/about" className="cursor-pointer hover:text-accent-300">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-white">
              <Link to="/category/action" className="cursor-pointer hover:text-accent-300">电影分类</Link>
            </h4>
            <ul className="grid grid-cols-2 gap-2 text-sm text-background-300">
              {categories.slice(0, 6).map((c) => (
                <li key={c.key}>
                  <Link to={`/category/${c.key}`} className="cursor-pointer hover:text-accent-300">
                    {c.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-white">友情链接</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li><span className="cursor-default">电影资料库</span></li>
              <li><span className="cursor-default">影迷社区</span></li>
              <li><span className="cursor-default">影视资讯站</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-sm text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 高清电影 · 本站所有内容均为演示数据，仅供学习交流使用。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base"></i>
            演示站点 · 不提供真实播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}